<script lang="ts" setup>
// DataQualityBadge (DEV-595, C2) — badge de qualité dataV2.
//  • variant "color"   → pastille colorée + libellé (tableau).
//  • variant "opacity" → carré gris à l'opacité de la qualité + libellé
//    (graphes : la qualité est encodée en OPACITÉ, la couleur sert aux séries).
import { computed } from "vue"
import { quality, type ProvenanceCode } from "./dataQuality"

const props = withDefaults(
    defineProps<{
        code: ProvenanceCode | number
        variant?: "color" | "opacity"
    }>(),
    { variant: "color" }
)

const q = computed(() => quality(props.code))
</script>

<template>
    <span
        v-if="variant === 'opacity'"
        class="inline-flex items-center gap-1.5 text-xs font-medium text-slate-600 whitespace-nowrap"
    >
        <span
            class="h-3 w-3 rounded-sm bg-slate-500"
            :style="{ opacity: q.opacity }"
        ></span>
        {{ q.label }}
    </span>
    <span
        v-else
        class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap"
        :style="{ color: q.color, backgroundColor: q.bg }"
    >
        {{ q.label }}
    </span>
</template>
